import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const stages = [
  { id: 1, title: 'Alpha Build', status: 'completed', date: 'Oct 15' },
  { id: 2, title: 'Beta Testing', status: 'completed', date: 'Nov 01' },
  { id: 3, title: 'Marketing Assets', status: 'active', date: 'Nov 12' },
  { id: 4, title: 'Press Briefings', status: 'pending', date: 'Nov 20' },
  { id: 5, title: 'IGNITION', status: 'pending', date: 'Nov 26' },
];

const StageGates = () => {
  return (
    <div className="relative">
      {/* Connecting Line */}
      <div className="absolute top-5 left-0 w-full h-0.5 bg-slate-800 z-0">
        <motion.div 
          initial={{ width: 0 }}
          animate={{ width: '50%' }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
          className="h-full bg-rocket-500 shadow-[0_0_10px_rgba(249,115,22,0.8)]"
        />
      </div>

      <div className="flex justify-between relative z-10 overflow-x-auto pb-4 hide-scrollbar">
        {stages.map((stage, index) => (
          <div key={stage.id} className="flex flex-col items-center min-w-[100px]">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-colors duration-300 ${
              stage.status === 'completed' ? 'bg-slate-900 border-rocket-500 text-rocket-500' :
              stage.status === 'active' ? 'bg-rocket-600 border-rocket-400 text-ice shadow-[0_0_15px_rgba(249,115,22,0.5)]' :
              'bg-slate-900 border-slate-700 text-slate-600'
            }`}>
              {stage.status === 'completed' ? <SafeIcon name="Check" /> : 
               stage.status === 'active' ? <span className="animate-pulse w-2 h-2 bg-white rounded-full"></span> : 
               <span className="text-sm font-mono">{stage.id}</span>}
            </div>
            
            <div className="mt-3 text-center">
              <p className={`text-xs font-semibold whitespace-nowrap ${
                stage.status === 'active' ? 'text-rocket-400' : 
                stage.status === 'completed' ? 'text-slate-300' : 'text-slate-500'
              }`}>{stage.title}</p>
              <p className="text-[10px] font-mono text-slate-500 mt-1">{stage.date}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StageGates;